class Permissions {
	static JOIN_CIRCLES = 1;
	static JOIN_COMMUNITIES = 2;
	static EDIT_ACCOUNT = 3;
	static EDIT_SUBSCRIPTION = 4;
	static MANAGE_OWN_LAYERS = 5;
	static MANAGE_OWN_RESOURCES = 6;
	static MANAGE_OWN_GRAPHICS = 7;

	static LABELS = {
		[this.JOIN_CIRCLES]: _('Join or Create Circles'),
		[this.JOIN_COMMUNITIES]: _('Join or Create Communities'),
		[this.EDIT_ACCOUNT]: _('Edit Account'),
		[this.EDIT_SUBSCRIPTION]: _('Edit Subscription'),
		[this.MANAGE_OWN_LAYERS]: _('Manage own timeline layers'),
		[this.MANAGE_OWN_RESOURCES]: _('Manage own resources'),
		[this.MANAGE_OWN_GRAPHICS]: _('Manage own graphics')
	};

	static currentUser() {
		let inst = new Permissions(null);
		if (userPermission >= 0) inst._value = userPermission;
		return inst;
	}

	constructor(circle_id) {
		this.circleId = circle_id;
		this._value = null;

		this.chkBoxes = [];

		this._dialog = null;
		this._permissionForm = null;
	}

	get dialog() {
		if (this._dialog == null) {
			this._dialog = Dialog.Modal('permissions', _("Permissions"), LARGE, _("SAVE PERMISSIONS"), this.form);
		}
		return this._dialog;
	}

	get form() {
		if (this._permissionForm == null) {
			this._permissionForm = UI.form([
				UI.div(
					'grid grid-cols-1', 
					Object.keys(Permissions.LABELS).map(key => {
						return (new PermissionRow(this, key, Permissions.LABELS[key])).rowElem;
					})
				)
			]);
		}
		return this._permissionForm;
	}

	get value() {
		let newValue = 0;
		for (let r of this.chkBoxes) {
			if (r.checked) {
				newValue += (1 << r.value);
			}
		}
		return newValue;
	}

	get isProtected() {
		return this._value !== null;
	}

	bit(b) {
		return (this._value & (1 << b)) !== 0;
	}

	can(permission) {
		if (this._value === null) return true;
		return this.bit(permission);
	}

	open() {
		API.fetch(
			`circles/${this.circleId}/permissions`
		)
		.then(reply => {
			this._value = reply.permissions;
			this.dialog.open(this.save.bind(this));
		});
	}

	save() {
		let newValue = this.value;
		if (this._value == newValue) return;

		this._value = newValue;
		API.update(
			`circles/${this.circleId}/permissions`,
			{
				permission: this._value
			}
		)
		.then(reply => {
			if (showError(reply)) return;
			makeToast(_("Permissions updates"));
		});
	}
}

class PermissionRow {
	constructor(parent, value, label) {
		this.parent = parent;

		this.rowElem = UI.div(
			'p-3',
			UI.label([
				this.chk = UI.chk(value),
				UI.span('p-2', label)
			])
		);

		this.chk.checked = (this.parent._value & (1 << value)) > 0;
		this.parent.chkBoxes.push(this.chk);
	}
}